module.exports = __webpack_public_path__ + "img/message-arrow-up-right.e895a175.svg";